import _ from 'lodash';
import React from 'react';
import { Contexts } from '../types';
import useEventBus from '../hooks/useEventBus';

const initialState: Contexts.MobileMenu = {
  // Menu opener boolean
  expanded: false,
  collapsing: false,
  // List of active menus
  actives: [],
}

// Shared menu context
export const MobileMenuContext = React.createContext<any>(initialState)

/**
 * Menu context provider
 * @returns React FC
 */
const MobileMenuProvider: React.FC = ({ children }) => {
  const [state, setState] = React.useState(initialState)
  const eventBus = useEventBus();

  // Toggles any boolean state
  const toggleBoolState = (property: string, force?: boolean) => {
    setState((currState: any) => {
      return {
        ...currState,
        [property]: _.isUndefined(force) ? !currState[property] : force,
      }
    })
  }

  // Pushes an ID to the list
  const handleNext = (subMenuId: string) => {
    
    setState((currState: Contexts.MobileMenu) => {
      return {
        ...currState,
        actives: currState.actives.concat(subMenuId),
      }
    })
  }

  // Removes the last element off the list
  const handlePrevious = () => {
    setState((currState: Contexts.MobileMenu) => {
      return {
        ...currState,
        actives: currState.actives.slice(0, currState.actives.length - 1),
      }
    })
  }

  // Removes all the elements of the list, except the first one
  const handleReset = () => {

    setState((currState: Contexts.MobileMenu) => {
      return {
        ...initialState,
        actives: currState.actives.slice(0, 1),
      }
    })

  }

  const handleBeforeReset = (timingBase: number) => {

    if ( ! state.collapsing && state.expanded ) {
      toggleBoolState('collapsing');
      
      setTimeout(() => {
        handleReset();
      }, timingBase)
    }

  }

  const handleToggle = () => toggleBoolState('expanded');

  React.useEffect(() => {
    eventBus.on('toggleMobileMenu', handleToggle);
    return () => eventBus.remove('toggleMobileMenu', handleToggle);
  }, []);

  return (
    <MobileMenuContext.Provider
      value={{
        state,
        // Hamburger component
        toggleBoolState,
        // Menu + Item component
        handleNext,
        // Category component
        handlePrevious,
        // Category + Item component
        handleReset,
        handleBeforeReset
      }}
      children={children}
    />
  )
}

export default MobileMenuProvider
